// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"ca52f655","171":"65fe5a34","310":"83d59909","397":"dfd93f02","512":"f474d3c8","591":"8b037245","731":"e0640dce","733":"ff5021fd","749":"ecbe075d","750":"fb2ae291","873":"7e991df4","895":"bc7d319b"}[chunkId] + ".chunk.js";
};